module.exports = __webpack_public_path__ + "static/media/bitbucket-logo.2b1428aa.svg";